export default "__VITE_ASSET__2TCp9g9I__"